<template>
  <main id="app" class="main_wrap"  :class="{ 'with-warning': !isExtensionInstalled }">
    <Sidebar />
    <Header :isExtensionInstalled="isExtensionInstalled" />
    <div class="layout_main_container">
      <div>
        <router-view v-if="templateStore.isCalled" />
      </div>
      <Footer />
    </div>
    <GoTop />
    <ProgressBarStack />
  </main>
</template>
<script>
import Sidebar from '@/components/layout/app/partials/Sidebar';
import Header from '@/components/layout/app/partials/Header';
import Footer from '@/components/layout/app/partials/Footer';
import GoTop from '@/components/layout/app/components/GoTop';
import chromeExAPI from '@/chromeExAPI';
import ProgressBarStack from '@/components/common/ProgressBarStack.vue';
export default {
  components: {
    ProgressBarStack,
    Header,
    Sidebar,
    Footer,
    GoTop
  },
  data() {
    return {
      isExtensionInstalled: true
    };
  },
  async created() {
    this.isExtensionInstalled = await chromeExAPI.isExtensionInstalled();
    if (this.authStore.user === null) {
      await this.authStore.setupUser();
    }
    this.ws_connect();

    if (!this.templateStore.isCalled) {
      this.templateStore.setTemplateList();
    }
  },
  watch: {
/*    'authStore.user'(user) {
      if (user !== null) {
        this.ws_connect();
      }
    },*/
    'socketStore.type'(type) {
      if (type !== '') {
        this.socketStore.setStatus(type);
        this.socketStore.setProgress('start');
      }
    },
    // socketIdx가 변경될 때마다 title 업데이트
    'socketStore.socketIdx'(newSocketIdx) {
      this.updateTitleWithSocketIdx();
    },
    // 라우트 변경 시에도 title 업데이트
    '$route'() {
      this.updateTitleWithSocketIdx();
    }
  },
  methods: {
    // Title에 socketIdx 추가하는 함수
    updateTitleWithSocketIdx() {
      const socketIdx = this.socketStore.getSocketIdx();
      if (socketIdx === null || socketIdx === undefined) {
        // socketIdx가 없으면 기존 패턴만 제거
        const existingPrefixPattern = /^\d+\s*-\s*/;
        const currentTitle = document.title;
        document.title = currentTitle.replace(existingPrefixPattern, '');
        return;
      }
      
      // 현재 title 가져오기
      const currentTitle = document.title;
      
      // 기존 socketIdx 패턴 제거 (맨 앞의 숫자- 패턴)
      const existingPrefixPattern = /^\d+\s*-\s*/;
      let baseTitle = currentTitle.replace(existingPrefixPattern, '');
      
      // socketIdx가 이미 포함되어 있는지 확인 (맨 앞에 같은 socketIdx가 있는지)
      const socketIdxPrefixPattern = new RegExp(`^${socketIdx}\\s*-\\s*`);
      if (socketIdxPrefixPattern.test(currentTitle)) {
        return; // 이미 포함되어 있으면 업데이트하지 않음
      }
      
      // 새로운 title 설정: socketIdx를 맨 앞에 붙임
      document.title = `${socketIdx}-${baseTitle}`;
    }
  }
};
</script>
<style lang="scss">
main.main_wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .layout_main_container {
    width: calc(100% - 240px);
    margin-top: 60px;
    margin-left: 240px;
    display: flex;
    flex-direction: column;
    background-color: $background;
    transition: margin-top 0.3s ease-in-out;

    flex-grow: 1;
  }

  &.with-warning .layout_main_container {
    margin-top: 100px;
  }
}
</style>
